/**
 * Takes an input string and splits it based on the deliminators
 * @param input
 * @param delimiters
 * @returns {*|*[]}
 */
export default function separateStrings(input, delimiters) {
  // Escape characters that have special meaning in regular expressions
  const escapedDelimiters = delimiters.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  // Create a regular expression pattern using the escaped delimiters
  const pattern = new RegExp("[" + escapedDelimiters + "]", "g")
  // Split the string into an array based on the delimiters
  return input ? input.split(pattern) : []
}
